import {count, distribution} from 'metrics/Metrics';

const snapshotExportMetrics = {
  chipHits: new Map<string, number>(),
  chipMisses: new Map<string, number>(),
  chipResolutionMs: new Map<string, number>(),
  chipTotalLookups: 0,
};

export function resetSnapshotExportMetrics(): void {
  snapshotExportMetrics.chipHits.clear();
  snapshotExportMetrics.chipMisses.clear();
  snapshotExportMetrics.chipResolutionMs.clear();
  snapshotExportMetrics.chipTotalLookups = 0;
}

export function incrementSnapshotHit(chipType: string): void {
  snapshotExportMetrics.chipTotalLookups++;
  snapshotExportMetrics.chipHits.set(chipType, (snapshotExportMetrics.chipHits.get(chipType) ?? 0) + 1);
}

export function incrementSnapshotMiss(chipType: string, reason: string): void {
  snapshotExportMetrics.chipTotalLookups++;
  const key = `${chipType}:${reason}`;
  snapshotExportMetrics.chipMisses.set(key, (snapshotExportMetrics.chipMisses.get(key) ?? 0) + 1);
}

export function incrementSnapshotResolutionMs(chipType: string, elapsedMs: number): void {
  snapshotExportMetrics.chipResolutionMs.set(
    chipType,
    (snapshotExportMetrics.chipResolutionMs.get(chipType) ?? 0) + elapsedMs
  );
}

/** Emit accumulated chip metrics to Datadog and reset. Called on SnapshotContextProvider unmount. */
export function flushSnapshotExportMetrics(flagEnabled: boolean): void {
  const m = snapshotExportMetrics;
  if (m.chipTotalLookups === 0) {
    return;
  }

  const tags = (chipType: string): {chip_type: string; flag_enabled: boolean} => ({
    chip_type: chipType,
    flag_enabled: flagEnabled,
  });

  distribution('snapshot_export.chip_total_lookups', m.chipTotalLookups, {flag_enabled: flagEnabled});

  for (const [chipType, v] of m.chipHits) {
    count('snapshot_export.chip_hits', v, tags(chipType));
  }

  for (const [chipType, v] of m.chipResolutionMs) {
    distribution('snapshot_export.chip_resolution_ms', v, tags(chipType));
  }

  for (const [key, v] of m.chipMisses) {
    const [chipType, reason] = key.split(':');
    count('snapshot_export.chip_misses', v, {...tags(chipType), reason});
  }

  if (m.chipMisses.size === 0) {
    count('snapshot_export.chip_misses', 0, {chip_type: 'all', reason: 'none', flag_enabled: flagEnabled});
  }

  resetSnapshotExportMetrics();
}
